import {
    AddressForm,
    convertFromBoolean,
    Form,
    FormCustomPlaceAutocomplete,
    FormDropDown,
    FormInput,
    FormRadio,
    FormSwitch,
} from 'metrix-common3';
// biome-ignore lint/correctness/noUnusedImports: required for jsx
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileSupernovaCommercialBusinessInfo = ({
    pageCode,
    doUpsertPolicy,
    doGetPolicy,
    allowEdit,
    policy,
    doReducePolicyElement,
    reference,
    tooltipInfo,
    validationInfo,
    doUpsertTooltipInfo,
    doReduceTooltipInfoElement,
    doUpdatePlace,
    context,
    productSettings,
}) => (
    <>
        <Form
            pageCode={pageCode}
            sectionCode='companyInformationLookup'
            header={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.companyInformationLookup' />}
            tooltipInfo={tooltipInfo}
            validationInfo={validationInfo}
            saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
            reduceTooltipInfoElement={doReduceTooltipInfoElement}
            //saveEvent={doUpsertPolicy}
            //cancelEvent={doGetPolicy}
            allowEdit={allowEdit}
            alwaysEditing={true}
        >
            <FormCustomPlaceAutocomplete
                querryCode='sn'
                handleClickApply={doUpdatePlace}
                fieldCode='snCommercialBusinessInfo.companyLookup'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.companyLookup' />}
                context={context}
                allowEdit
                alwaysVisible
            />
        </Form>

        <Form
            pageCode={pageCode}
            sectionCode='companyInformation'
            header={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.companyInformation' />}
            tooltipInfo={tooltipInfo}
            validationInfo={validationInfo}
            saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
            reduceTooltipInfoElement={doReduceTooltipInfoElement}
            saveEvent={doUpsertPolicy}
            cancelEvent={doGetPolicy}
            allowEdit={allowEdit}
        >
            <FormInput
                fieldCode='snCommercialBusinessInfo.doingBusinessAs'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.doingBusinessAsName' />}
                value={policy.snCommercialBusinessInfo.doingBusinessAs}
                type='text'
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'snCommercialBusinessInfo.doingBusinessAs',
                        value,
                    })
                }
                allowEdit
            />
            <FormInput
                fieldCode='snCommercialBusinessInfo.legalBusinessName'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.legalBusinessName' />}
                value={policy.snCommercialBusinessInfo.legalBusinessName}
                type='text'
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'snCommercialBusinessInfo.legalBusinessName',
                        value,
                    })
                }
                allowEdit
            />
            {
                <FormRadio
                    fieldCode='snCommercialBusinessInfo.isCompanyPlaceIdValidationSuccessful'
                    label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.placeIdValidationStatus' />}
                    value={
                        policy.snCommercialBusinessInfo.isCompanyPlaceIdValidationSuccessful !== undefined && {
                            code: convertFromBoolean(
                                policy.snCommercialBusinessInfo.isCompanyPlaceIdValidationSuccessful,
                            ),
                        }
                    }
                    references={reference?.references.YesNo}
                    referencesEvent={() => reference.doGetReferences('YesNo')}
                    changeEvent={(_value) => null}
                    allowEdit={false}
                />
            }
        </Form>

        <AddressForm
            enableAddressSearch
            pageCode={pageCode}
            sectionCode='applicantAddressDetails'
            saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
            reduceTooltipInfoElement={doReduceTooltipInfoElement}
            tooltipInfo={tooltipInfo}
            validationInfo={validationInfo}
            addressSearchCountryCode={`${policy.productCountryCode ? policy.productCountryCode : 'USA'}`}
            header={<FormattedMessage id='Profile_Insured.addressDetails' />}
            label={<FormattedMessage id='Profile_Insured.locationDetails' />}
            reference={reference}
            allowEdit={false}
            isAddressAutofillEnforce={productSettings?.isAddressAutofillEnforce}
            address={policy?.participants?.insured?.party?.address}
        />

        <Form
            pageCode={pageCode}
            sectionCode='businessInformation'
            header={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.businessInformation' />}
            tooltipInfo={tooltipInfo}
            validationInfo={validationInfo}
            saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
            reduceTooltipInfoElement={doReduceTooltipInfoElement}
            saveEvent={doUpsertPolicy}
            cancelEvent={doGetPolicy}
            allowEdit={allowEdit}
        >
            <FormInput
                fieldCode='snCommercialBusinessInfo.fus'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.fireUnderwritersSurvey' />}
                value={policy.snCommercialBusinessInfo.fus}
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'snCommercialBusinessInfo.fus',
                        value,
                    })
                }
                type='number'
                allowEdit={allowEdit}
            />

            <FormInput
                fieldCode='snCommercialBusinessInfo.businessInfoYearEstablished'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.yearBusinessEstablished' />}
                value={policy.snCommercialBusinessInfo.businessInfoYearEstablished}
                type='number'
                maxValue={2100}
                minValue={1800}
                overrideMaxLength={4}
                changeEvent={(value) => {
                    const date = new Date();
                    const currentYear = date.getFullYear();
                    if (currentYear - value <= 1) {
                        doReducePolicyElement({
                            code: 'policy.snCommercialBusinessInfo.isNewBusines',
                            value: true,
                        });
                    } else {
                        doReducePolicyElement({
                            code: 'policy.snCommercialBusinessInfo.isNewBusines',
                            value: false,
                        });
                    }

                    doReducePolicyElement({
                        code: 'snCommercialBusinessInfo.businessInfoYearEstablished',
                        value,
                    });
                }}
                allowEdit
            />

            <FormDropDown
                fieldCode='snCommercialBusinessInfo.businessInfoEmployeeCountCode'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.numberOfEmployees' />}
                value={{ code: policy.snCommercialBusinessInfo.businessInfoEmployeeCountCode }}
                references={reference?.references['sn-commercial']?.EmployeeCountGroups}
                referencesEvent={() => reference.doGetReferences('sn-commercial.EmployeeCountGroups')}
                changeEvent={(value) => {
                    doReducePolicyElement({
                        code: 'snCommercialBusinessInfo.businessInfoEmployeeCountCode',
                        value: value.code,
                    });
                }}
                allowEdit
            />
            <FormInput
                fieldCode='snCommercialBusinessInfo.businessInfoRevenueAmount'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.yearlyRevenueAmount' />}
                value={policy.snCommercialBusinessInfo.businessInfoRevenueAmount}
                type='currency'
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'snCommercialBusinessInfo.businessInfoRevenueAmount',
                        value,
                    })
                }
                allowEdit
            />
            {/*If Industry Category is CEI*/}
            {policy.snCommercialBusinessInfo.doesClientUseSubcontractorsDisplayed && (
                <FormSwitch
                    fieldCode='snCommercialBusinessInfo.doesClientUseSubcontractors'
                    label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.useSubcontractors' />}
                    value={policy.snCommercialBusinessInfo.doesClientUseSubcontractors}
                    changeEvent={(value) =>
                        doReducePolicyElement({
                            code: 'snCommercialBusinessInfo.doesClientUseSubcontractors',
                            value,
                        })
                    }
                    allowEdit
                />
            )}
            {policy.snCommercialBusinessInfo.doesClientUseSubcontractorsDisplayed &&
                policy.snCommercialBusinessInfo.doesClientUseSubcontractors && (
                    <FormSwitch
                        fieldCode='snCommercialBusinessInfo.doesClientUseCertificatesOfInsuranceFromSubcontractors'
                        label={
                            <FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.obtainCertificatesFromSubcontractors' />
                        }
                        value={policy.snCommercialBusinessInfo.doesClientUseCertificatesOfInsuranceFromSubcontractors}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialBusinessInfo.doesClientUseCertificatesOfInsuranceFromSubcontractors',
                                value,
                            })
                        }
                        allowEdit
                    />
                )}
        </Form>
        <Form
            pageCode={pageCode}
            sectionCode='industryInformation'
            header={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.industry' />}
            tooltipInfo={tooltipInfo}
            validationInfo={validationInfo}
            saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
            reduceTooltipInfoElement={doReduceTooltipInfoElement}
            saveEvent={doUpsertPolicy}
            cancelEvent={doGetPolicy}
            allowEdit={allowEdit}
        >
            <FormDropDown
                fieldCode='snCommercialBusinessInfo.industryPrimaryCode'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.mainIndustry' />}
                value={{ code: policy.snCommercialBusinessInfo.industryPrimaryCode }}
                references={reference?.references['sn-commercial']?.IndustryCodes}
                referencesEvent={() => reference.doGetReferences('sn-commercial.IndustryCodes')}
                changeEvent={(value) => {
                    doReducePolicyElement({
                        code: 'snCommercialBusinessInfo.industryPrimaryCode',
                        value: value.code,
                    });
                    doReducePolicyElement({
                        code: 'snCommercialBusinessInfo.industryPrimaryName',
                        value: value.value,
                    });
                }}
                allowEdit
            />
            <FormInput
                fieldCode='snCommercialBusinessInfo.primaryIndustryCategory'
                label={<FormattedMessage id='Profile_SupernovaCommercial_BusinessInfo.primaryCategory' />}
                value={policy.snCommercialBusinessInfo.primaryIndustryCategory}
                type='text'
                allowEdit={false}
            />
            {/*<FormSwitch*/}
            {/*    fieldCode='snCommercialBusinessInfo.hasSecondaryIndustry'*/}
            {/*    label={<FormattedMessage id="Profile_SupernovaCommercial_BusinessInfo.hasSecondaryIndustry" />}*/}
            {/*    value={policy.snCommercialBusinessInfo.hasSecondaryIndustry}*/}
            {/*    changeEvent={value => doReducePolicyElement({*/}
            {/*        code: 'snCommercialBusinessInfo.hasSecondaryIndustry',*/}
            {/*        value*/}
            {/*    })}*/}
            {/*    allowEdit*/}
            {/*/>*/}
            {/*{*/}
            {/*    policy.snCommercialBusinessInfo.hasSecondaryIndustry &&*/}
            {/*    <FormDropDown*/}
            {/*        fieldCode='snCommercialBusinessInfo.industrySecondaryCode'*/}
            {/*        label={<FormattedMessage id="Profile_SupernovaCommercial_BusinessInfo.secondaryIndustry" />}*/}
            {/*        value={{ code: policy.snCommercialBusinessInfo.industrySecondaryCode }}*/}
            {/*        references={reference?.references['sn-commercial']?.IndustryCodes}*/}
            {/*        referencesEvent={() => reference.doGetReferences('sn-commercial.IndustryCodes')}*/}
            {/*        changeEvent={value => {*/}
            {/*            doReducePolicyElement({*/}
            {/*                code: 'snCommercialBusinessInfo.industrySecondaryCode',*/}
            {/*                value: value.code*/}
            {/*            });*/}
            {/*            doReducePolicyElement({*/}
            {/*                code: 'snCommercialBusinessInfo.industrySecondaryName',*/}
            {/*                value: value.value*/}
            {/*            });*/}
            {/*        }}*/}
            {/*        allowEdit*/}
            {/*    />*/}
            {/*}*/}
            {/*{*/}
            {/*    policy.snCommercialBusinessInfo.hasSecondaryIndustry &&*/}
            {/*    <FormInput*/}
            {/*        fieldCode='snCommercialBusinessInfo.secondaryIndustryCategory'*/}
            {/*        label={<FormattedMessage id="Profile_SupernovaCommercial_BusinessInfo.secondaryCategory" />}*/}
            {/*        value={policy.snCommercialBusinessInfo.secondaryIndustryCategory}*/}
            {/*        type='text'*/}
            {/*        allowEdit={false}*/}
            {/*    />*/}
            {/*}*/}
            {/*{*/}
            {/*    policy.snCommercialBusinessInfo.hasSecondaryIndustry &&*/}
            {/*    <FormDropDown*/}
            {/*        fieldCode='snCommercialBusinessInfo.percEarningsFromSecIndustryCode'*/}
            {/*        label={<FormattedMessage id="Profile_SupernovaCommercial_BusinessInfo.earningsFromSecondaryIndustry" />}*/}
            {/*        value={{ code: policy.snCommercialBusinessInfo.percEarningsFromSecIndustryCode }}*/}
            {/*        references={reference?.references['sn-commercial']?.PercEarningsFromSecInd}*/}
            {/*        referencesEvent={() => reference.doGetReferences('sn-commercial.PercEarningsFromSecInd')}*/}
            {/*        changeEvent={value => {*/}
            {/*            doReducePolicyElement({*/}
            {/*                code: 'snCommercialBusinessInfo.percEarningsFromSecIndustryCode',*/}
            {/*                value: value.code*/}
            {/*            });*/}
            {/*        }}*/}
            {/*        allowEdit*/}
            {/*    />*/}
            {/*}*/}
        </Form>
    </>
);

export default ProfileSupernovaCommercialBusinessInfo;
